module.exports = __webpack_public_path__ + "media/images/footer_whitepaper-9bdf13d2627c4b53558cc93004d82401.png";